// @flow
import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import styles from './styles';

type Props = {
  make: ?string,
  model: ?string,
};

const { fewResultsCarsSnippetModel } = defineMessages({
  fewResultsCarsSnippetModel: {
    id: 'global_few_results_cars_snippet_model',
    defaultMessage: 'Car similar to {%1$s}',
  },
});

function composeMakeModelString(make: string, model: string): string {
  if (make && model) {
    return `${make} ${model}`;
  }

  if (make) {
    return make;
  }

  return model;
}

function FewResultsCarsByModelMessage({ make, model }: Props) {
  if (!make || !model) {
    return null;
  }

  const makeModel = composeMakeModelString(make, model);

  return (
    <div className="few-results-message">
      <span>
        <FormattedMessage
          {...fewResultsCarsSnippetModel}
          values={{
            '%1$s': makeModel,
          }}
        />
      </span>
      <style jsx>{styles}</style>
    </div>
  );
}

FewResultsCarsByModelMessage.defaultProps = {
  model: null,
};

export default FewResultsCarsByModelMessage;



// WEBPACK FOOTER //
// ./app/common/FewResultsMessages/cars/index.js